module.exports = __webpack_public_path__ + "img/program-noimage.dc83ca85.png";